import { ThemeTypographyObject } from '../../types/theme';

type CHARTLegacyTypeHeadings = 'CHARTheadlineXL'
  | 'CHARTheadlineL'
  | 'CHARTheadlineM'
  | 'CHARTheadlineS'
  | 'CHARTheadlineXS'
  | 'CHARTsubheadXL'
  | 'CHARTsubheadL'
  | 'CHARTsubheadM'
  | 'CHARTsubheadS'
  | 'CHARTsubheadXS'
  | 'CHARTsubheadXXS'
  | 'CHARTsubheadXXXS'
  | 'CHARTcardTitle'
  | 'CHARTsubheadM700'
  | 'CHARTsubheadXS700';

type LegacyCHARTHeadingVariants = {
  [key in CHARTLegacyTypeHeadings]: ThemeTypographyObject
};

const chartLegacyHeadingsVariants: LegacyCHARTHeadingVariants = {
  CHARTheadlineXL: {
    color: 'heading',
    fontSize: [9, 10, 11, 12],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  CHARTheadlineL: {
    color: 'heading',
    fontSize: [8, 9, 10, 11],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  CHARTheadlineM: {
    color: 'heading',
    fontSize: [7, 8, 9, 10],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  CHARTheadlineS: {
    color: 'heading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  CHARTheadlineXS: {
    color: 'heading',
    fontSize: [5, 6, 7, 8],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 5
  },
  CHARTsubheadXL: {
    color: 'subheading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 7
  },
  CHARTsubheadL: {
    color: 'subheading',
    fontSize: [5, 6, 7, 8],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  CHARTsubheadM: {
    color: 'subheading',
    fontSize: [4, 5, 6, 7],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  CHARTsubheadS: {
    color: 'subheading',
    fontSize: [3, 4, 5, 6],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  CHARTsubheadXS: {
    color: 'subheading',
    fontSize: [2, 3, 4, 5],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  CHARTsubheadXXS: {
    color: 'subheading',
    fontSize: [2, 3, 3, 4],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 4
  },
  CHARTsubheadXXXS: {
    color: 'subheading',
    fontSize: [1, 2, 3],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 8
  },
  CHARTcardTitle: {
    color: 'heading',
    fontSize: 4,
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0
  },
  CHARTsubheadM700: {
    fontWeight: 'bold',
    fontSize: [4, 5, 7],
    lineHeight: 1.02,
    color: 'coolGrey.100'
  },
  CHARTsubheadXS700: {
    fontWeight: 'bold',
    fontSize: 5,
    lineHeight: 0.96,
    color: 'coolGrey.100'
  }
};

type COLegacyTypeHeadings = 'COheadlineXL'
  | 'COheadlineL'
  | 'COheadlineM'
  | 'COheadlineS'
  | 'COheadlineXS'
  | 'COsubheadXL'
  | 'COsubheadL'
  | 'COsubheadM'
  | 'COsubheadS'
  | 'COsubheadXS'
  | 'COsubheadXXS'
  | 'COcardTitle'
  | 'COsubheadL700'
  | 'COsubheadM700'
  | 'COsubheadS700'
  | 'COsubheadXS700'
  | 'COsubheadXXS700'
  | 'COheadlineM700'
  | 'COheadlineS700'
  | 'COheadlineXS700';

type LegacyCOHeadingVariants = {
  [key in COLegacyTypeHeadings]: ThemeTypographyObject
};

const coLegacyHeadingsVariants: LegacyCOHeadingVariants = {
  COheadlineXL: {
    color: 'heading',
    fontSize: [9, 10, 11, 12],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  COheadlineL: {
    color: 'heading',
    fontSize: [8, 9, 10, 11],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  COheadlineM: {
    color: 'heading',
    fontSize: [7, 8, 9, 10],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  COheadlineS: {
    color: 'heading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  COheadlineXS: {
    color: 'heading',
    fontSize: [5, 6, 7, 8],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 5
  },
  COsubheadXL: {
    color: 'subheading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 7
  },
  COsubheadL: {
    color: 'subheading',
    fontSize: [5, 6, 7, 8],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  COsubheadM: {
    color: 'subheading',
    fontSize: [4, 5, 6, 7],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  COsubheadS: {
    color: 'subheading',
    fontSize: [3, 4, 5, 6],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  COsubheadXS: {
    color: 'subheading',
    fontSize: [2, 3, 4, 5],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  COsubheadXXS: {
    color: 'subheading',
    fontSize: [2, 3, 3, 4],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 4
  },
  COcardTitle: {
    color: 'heading',
    fontSize: 4,
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0
  },
  COsubheadL700: {
    fontWeight: 700,
    fontSize: 8,
    lineHeight: 0.98,
    color: 'coolGrey.100'
  },
  COsubheadM700: {
    fontWeight: 700,
    fontSize: 7,
    lineHeight: 1.02,
    color: 'coolGrey.100'
  },
  COsubheadS700: {
    fontWeight: 700,
    fontSize: 6,
    lineHeight: 1.02,
    color: 'coolGrey.100'
  },
  COsubheadXS700: {
    fontWeight: 700,
    fontSize: 5,
    lineHeight: 0.96,
    color: 'coolGrey.100'
  },
  COsubheadXXS700: {
    fontWeight: 700,
    fontSize: 4,
    lineHeight: 0.96,
    color: 'coolGrey.100'
  },
  COheadlineM700: {
    fontWeight: 700,
    fontSize: [9, 9, 10],
    lineHeight: 1.05,
    color: 'blue.60'
  },
  COheadlineS700: {
    fontWeight: 700,
    fontSize: 9,
    lineHeight: 1.05,
    color: 'blue.60'
  },
  COheadlineXS700: {
    fontWeight: 700,
    fontSize: 8,
    lineHeight: 0.98,
    color: 'blue.60'
  }
};

type EDULegacyTypeHeadings = 'EDUheadlineXL'
  | 'EDUheadlineL'
  | 'EDUheadlineM'
  | 'EDUheadlineS'
  | 'EDUheadlineXS'
  | 'EDUsubheadXL'
  | 'EDUsubheadL'
  | 'EDUsubheadM'
  | 'EDUsubheadS'
  | 'EDUsubheadXS'
  | 'EDUsubheadXXS'
  | 'EDUsubheadXXXS'
  | 'EDUassignmentTitle'
  | 'EDUcardTitle';

type LegacyEDUHeadingVariants = {
  [key in EDULegacyTypeHeadings]: ThemeTypographyObject
};

const eduLegacyHeadingsVariants: LegacyEDUHeadingVariants = {
  EDUheadlineXL: {
    color: 'heading',
    fontSize: [9, 10, 11, 12],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  EDUheadlineL: {
    color: 'heading',
    fontSize: [8, 9, 10, 11],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  EDUheadlineM: {
    color: 'heading',
    fontSize: [7, 8, 9, 10],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  EDUheadlineS: {
    color: 'heading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  EDUheadlineXS: {
    color: 'heading',
    fontSize: [4, 4, 5, 6],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginTop: 5,
    marginBottom: 5
  },
  EDUsubheadXL: {
    color: 'subheading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 7
  },
  EDUsubheadL: {
    color: 'subheading',
    fontSize: [5, 6, 7, 8],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  EDUsubheadM: {
    color: 'subheading',
    fontSize: [4, 5, 6, 7],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  EDUsubheadS: {
    color: 'subheading',
    fontSize: [3, 4, 5, 6],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  EDUsubheadXS: {
    color: 'subheading',
    fontSize: [2, 3, 4, 5],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  EDUsubheadXXS: {
    color: 'subheading',
    fontSize: [2, 3, 3, 4],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  EDUsubheadXXXS: {
    color: 'subheading',
    fontSize: [2, 3],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 3
  },
  EDUassignmentTitle: {
    color: 'heading',
    fontSize: 2,
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 2
  },
  EDUcardTitle: {
    color: 'heading',
    fontSize: 4,
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0
  }
};

type PRESSLegacyTypeHeadings = 'PRESSheadlineL'
  | 'PRESSheadlineM'
  | 'PRESSheadlineS'
  | 'PRESSheadlineXS'
  | 'PRESSsubheadL'
  | 'PRESSsubheadM'
  | 'PRESSsubheadS';

type LegacyPRESSHeadingVariants = {
  [key in PRESSLegacyTypeHeadings]: ThemeTypographyObject
};

const pressLegacyHeadingsVariants: LegacyPRESSHeadingVariants = {
  PRESSheadlineL: {
    color: 'heading',
    fontSize: [9, 10, 11, 12],
    fontWeight: 'boldest',
    lineHeight: 'default',
    margin: 0,
    marginBottom: 3
  },
  PRESSheadlineM: {
    color: 'heading',
    fontSize: [7, 8, 9, 10],
    fontWeight: 'heading',
    lineHeight: 'Default',
    marginTop: 6,
    marginBottom: 6
  },
  PRESSheadlineS: {
    color: 'heading',
    fontSize: [3, 4, 5, 6],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 4
  },
  PRESSheadlineXS: {
    color: 'heading',
    fontSize: [2, 3, 4, 5],
    fontWeight: 'boldest',
    lineHeight: 'default',
    margin: 0,
    marginBottom: 5
  },
  PRESSsubheadL: {
    color: 'subheading',
    fontSize: [3, 4, 5, 6],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  PRESSsubheadM: {
    color: 'subheading',
    fontSize: [2, 3, 4, 5],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  PRESSsubheadS: {
    color: 'subheading',
    fontSize: [1, 2, 3, 4],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  }
};

type SPARKLegacyTypeHeadings = 'SPARKheadlineXL'
  | 'SPARKheadlineL'
  | 'SPARKheadlineM'
  | 'SPARKheadlineS'
  | 'SPARKheadlineXS'
  | 'SPARKheadlineXS700'
  | 'SPARKsubheadXL'
  | 'SPARKsubheadL'
  | 'SPARKsubheadM'
  | 'SPARKsubheadS'
  | 'SPARKsubheadXS'
  | 'SPARKsubheadXXS'
  | 'SPARKblogInTextCtaHeader'
  | 'SPARKcardTitle'
  | 'SPARKsubheadL700'
  | 'SPARKsubheadM700'
  | 'SPARKsubheadS700'
  | 'SPARKsubheadXS700';

type LegacySPARKHeadingVariants = {
  [key in SPARKLegacyTypeHeadings]: ThemeTypographyObject
};

const sparkLegacyHeadingsVariants: LegacySPARKHeadingVariants = {
  SPARKheadlineXL: {
    color: 'heading',
    fontSize: [9, 10, 11, 12],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  SPARKheadlineL: {
    color: 'heading',
    fontSize: [8, 9, 10, 11],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 8
  },
  SPARKheadlineM: {
    color: 'heading',
    fontSize: [7, 8, 9, 10],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  SPARKheadlineS: {
    color: 'heading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 6
  },
  SPARKheadlineXS: {
    color: 'heading',
    fontSize: [5, 6, 7, 8],
    fontWeight: 'heading',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 5
  },
  SPARKheadlineXS700: {
    color: 'heading',
    fontSize: [7, 8],
    fontWeight: 'bolder',
    lineHeight: 'heading',
    margin: 0,
    marginBottom: 5
  },
  SPARKsubheadXL: {
    color: 'subheading',
    fontSize: [6, 7, 8, 9],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 7
  },
  SPARKsubheadL: {
    color: 'subheading',
    fontSize: 7,
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  SPARKsubheadM: {
    color: 'subheading',
    fontSize: [4, 5, 6, 7],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 6
  },
  SPARKsubheadS: {
    color: 'subheading',
    fontSize: [3, 4, 5, 6],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  SPARKsubheadXS: {
    color: 'subheading',
    fontSize: [2, 3, 4, 5],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  SPARKsubheadXXS: {
    color: 'subheading',
    fontSize: [2, 3, 3, 4],
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    marginBottom: 5
  },
  SPARKblogInTextCtaHeader: {
    color: 'primary',
    fontSize: 3,
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0,
    textTransform: 'uppercase'
  },
  SPARKcardTitle: {
    color: 'heading',
    fontSize: 4,
    fontWeight: 'subheading',
    lineHeight: 'subheading',
    margin: 0
  },
  SPARKsubheadL700: {
    fontWeight: 'bolder',
    fontSize: 7,
    lineHeight: 'subheading',
    color: 'subheading'
  },
  SPARKsubheadM700: {
    fontWeight: 'bolder',
    fontSize: 7,
    lineHeight: 'subheading',
    color: 'subheading'
  },
  SPARKsubheadS700: {
    fontWeight: 'bolder',
    fontSize: 6,
    lineHeight: 0.96,
    color: 'coolGrey.100'
  },
  SPARKsubheadXS700: {
    fontWeight: 'bolder',
    fontSize: 5,
    lineHeight: 0.96,
    color: 'coolGrey.100'
  }
};

export type AllLegacyHeadingTypeVariants = CHARTLegacyTypeHeadings
  | COLegacyTypeHeadings
  | EDULegacyTypeHeadings
  | PRESSLegacyTypeHeadings
  | SPARKLegacyTypeHeadings;

const legacyHeadingVariants = {
  ...chartLegacyHeadingsVariants,
  ...coLegacyHeadingsVariants,
  ...eduLegacyHeadingsVariants,
  ...pressLegacyHeadingsVariants,
  ...sparkLegacyHeadingsVariants
};

export const allLegacyHeadingKeyVariants = Object.keys(legacyHeadingVariants);

export default legacyHeadingVariants;
